import { Autocomplete, Box, FormControl, FormControlLabel, FormLabel, InputAdornment, Radio, RadioGroup, TextField, Typography } from "@mui/material";
import RequestQuoteRoundedIcon from '@mui/icons-material/RequestQuoteRounded';
import cnaeData from "../../../../data/static/CNAE.json";
import nbsData from "../../../../data/static/lista_nbs.json";
import { useEffect, useState } from "react";
import TooltipServiceProvisionCity from "./TooltipServiceProvisionCity";
import TooltipISSTaxJuridicionCity from "./TooltipISSTaxJuridicionCity";
import { FEDERAL_WITHHOLDING_OPTIONS, ISS_OPTIONS, PIS_COFINS_OPTIONS, SN_TAX_REGIME_OPTIONS } from "../../../../helpers/nfseHelpers";
import PercentNumberField from "../../../../../components/shared/inputs/PercentNumberField";
import AutocompleteWithRender from "../../../../../components/shared/inputs/AutoCompleteWithRender";
import TooltipSNTaxRegime from "./TooltipSNTaxRegime";

const cnaeOptions = cnaeData.map(item => ({
    label: `${item.code} - ${item.description}`,
    value: item.code
}));

const nbsOptions = nbsData.map(item => ({
    label: `${item.code} - ${item.description}`,
    value: item.code
}));

const issTaxCodeOptions = ISS_OPTIONS.map(item => ({
    label: `${item.value} - ${item.label}`,
    value: item.value
}));

const pisCofinsCodeOptions = PIS_COFINS_OPTIONS.map(item => ({
    label: `${item.value} - ${item.label}`,
    value: item.value
}));

const federalWithholdingOptions = FEDERAL_WITHHOLDING_OPTIONS.map(item => ({
    label: `${item.value} - ${item.label}`,
    value: item.value
}));


const FiscalConfigTaxData = ({ onValidityChange, data, setData }) => {

    useEffect(() => {
        const isValid =
            data.serviceCode.trim() !== '' && !!data.cnae && !!data.nbs && !!data.serviceLocation &&
            data.issIncidenceCity && data.issTaxationType !== null && data.issRetention !== null &&
            !!data.pisCofinsTaxSituationCode && !!data.pisCofinsRetentionCode;
        onValidityChange?.(isValid);
    }, [data, onValidityChange]);

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '2rem' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <RequestQuoteRoundedIcon sx={{ color: 'primary.main' }} />
                <Typography variant='h6' sx={{ color: 'primary.main' }}>Dados Fiscais</Typography>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                <FormLabel sx={{ mb: 1.3, color: 'text.primary' }}><b>Código do Serviço Municipal/Nacional </b> <FormLabel sx={{ color: 'error.main' }}><b>*</b></FormLabel></FormLabel>
                <TextField
                    variant="outlined"
                    placeholder='Ex: 100101'
                    sx={{ maxWidth: '10.75rem' }}
                    value={data.serviceCode}
                    onChange={(e) => setData({ ...data, serviceCode: e.target.value })}
                />

            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                <FormLabel sx={{ mb: 1.3, color: 'text.primary' }}><b>Código de Tributação Municipal </b></FormLabel>
                <TextField
                    variant="outlined"
                    placeholder='Ex: 001'
                    sx={{ maxWidth: '10.75rem' }}
                    value={data.localTaxCode}
                    onChange={(e) => setData({ ...data, localTaxCode: e.target.value })}
                />

            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                <FormLabel sx={{ mb: 1.3, color: 'text.primary' }}><b>CNAE </b> <FormLabel sx={{ color: 'error.main' }}><b>*</b></FormLabel></FormLabel>
                <AutocompleteWithRender
                    options={cnaeOptions}
                    value={cnaeOptions.find(opt => opt.value === data.cnae)}
                    sx={{ width: '30rem' }}
                    onChange={(val) => setData(prev => ({ ...prev, cnae: val?.value || "" }))}
                />
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                <FormLabel sx={{ mb: 1.3, color: 'text.primary' }}><b>Código NBS </b> <FormLabel sx={{ color: 'error.main' }}><b>*</b></FormLabel></FormLabel>
                <AutocompleteWithRender
                    options={nbsOptions}
                    value={nbsOptions.find(opt => opt.value === data.nbs)}
                    sx={{ width: '30rem' }}
                    onChange={(val) => setData(prev => ({ ...prev, nbs: val?.value || "" }))}
                />
            </Box>
            <Box>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <FormLabel sx={{ color: 'text.primary' }}><b> Cidade de prestação do Serviço </b><FormLabel sx={{ color: 'error.main' }}><b>*</b></FormLabel></FormLabel>
                    <TooltipServiceProvisionCity />
                </Box>
                <Box>
                    <FormControl >
                        <RadioGroup
                            row
                            sx={{ gap: '2rem' }}
                            value={data.serviceLocation}
                            onChange={(e) => setData({ ...data, serviceLocation: e.target.value })}
                        >

                            <FormControlLabel value="company_address" control={<Radio />} label="Endereço da Empresa" />
                            <FormControlLabel value="client_address" control={<Radio />} label="Endereço do Cliente" />
                        </RadioGroup>
                    </FormControl>
                </Box>
            </Box>
            <Box>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <FormLabel sx={{ color: 'text.primary' }}><b> Cidade de incidência do ISS </b><FormLabel sx={{ color: 'error.main' }}><b>*</b></FormLabel></FormLabel>
                    <TooltipISSTaxJuridicionCity />
                </Box>
                <Box>
                    <FormControl >
                        <RadioGroup
                            row
                            sx={{ gap: '2rem' }}
                            value={data.issIncidenceCity}
                            onChange={(e) => setData({ ...data, issIncidenceCity: e.target.value })}
                        >

                            <FormControlLabel value="company_address" control={<Radio />} label="Endereço da Empresa" />
                            <FormControlLabel value="client_address" control={<Radio />} label="Endereço do Cliente" />
                        </RadioGroup>
                    </FormControl>
                </Box>
            </Box>
            <Box sx={{ display: 'flex', gap: '2rem', alignItems: 'flex-end' }}>
                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                    <FormLabel sx={{ mb: 1.3, color: 'text.primary' }}><b>Tipo de Tributação do ISS </b> <FormLabel sx={{ color: 'error.main' }}><b>*</b></FormLabel></FormLabel>
                    <Autocomplete
                        disablePortal
                        options={issTaxCodeOptions}
                        value={issTaxCodeOptions.find(opt => opt.value === data.issTaxationType)}
                        getOptionLabel={(option) => option.label}
                        sx={{ width: '30rem' }}
                        onChange={(e, val) => setData(prev => ({ ...prev, issTaxationType: val?.value ? Number(val.value) : "" }))}
                        renderInput={(params) => (
                            <TextField {...params} placeholder="Selecionar" />
                        )}
                    />
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                    <FormLabel sx={{ mb: 1.3, color: 'text.primary' }}><b> Retenção do ISS </b><FormLabel sx={{ color: 'error.main' }}><b>*</b></FormLabel></FormLabel>
                    <Box>
                        <FormControl >
                            <RadioGroup
                                row
                                sx={{ gap: '2rem' }}
                                value={data.issRetention}
                                onChange={(e) => setData({ ...data, issRetention: e.target.value === 'true' })}
                            >

                                <FormControlLabel value={false} control={<Radio />} label="Não" />
                                <FormControlLabel value={true} control={<Radio />} label="Sim" />
                            </RadioGroup>
                        </FormControl>
                    </Box>
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                    <FormLabel sx={{ mb: 1.3, color: 'text.primary' }}><b> Alíquota do ISS </b></FormLabel>
                    <PercentNumberField
                        value={data.issRate || null}
                        onChange={(e) => setData({ ...data, issRate: e.target.value })}
                    />
                </Box>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <FormLabel sx={{ mb: 1.3, color: 'text.primary' }}><b>Regime de Apuração Tributária (Simples Nacional)</b></FormLabel>
                    <TooltipSNTaxRegime />
                </Box>
                <Autocomplete
                    disablePortal
                    options={SN_TAX_REGIME_OPTIONS}
                    value={SN_TAX_REGIME_OPTIONS.find(opt => opt.value === data.snTaxRegime)}
                    getOptionLabel={(option) => option.label}
                    sx={{ width: '30rem' }}
                    onChange={(e, val) => setData(prev => ({ ...prev, snTaxRegime: val?.value || '' }))}
                    renderInput={(params) => (
                        <TextField {...params} multiline placeholder="Selecionar" />
                    )}
                />
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                <FormLabel sx={{ mb: 1.3, color: 'text.primary' }}><b>Código de Situação Tributária de PIS e COFINS</b> <FormLabel sx={{ color: 'error.main' }}><b>*</b></FormLabel></FormLabel>
                <Autocomplete
                    disablePortal
                    options={pisCofinsCodeOptions}
                    value={pisCofinsCodeOptions.find(opt => opt.value === data.pisCofinsTaxSituationCode)}
                    getOptionLabel={(option) => option.label}
                    sx={{ width: '30rem' }}
                    onChange={(e, val) => setData(prev => ({ ...prev, pisCofinsTaxSituationCode: val?.value || '' }))}
                    renderInput={(params) => (
                        <TextField {...params} multiline placeholder="Selecionar" />
                    )}
                />
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                <FormLabel sx={{ mb: 1.3, color: 'text.primary' }}><b>Retenção de PIS, COFINS e CSLL </b> <FormLabel sx={{ color: 'error.main' }}><b>*</b></FormLabel></FormLabel>
                <Autocomplete
                    disablePortal
                    options={federalWithholdingOptions}
                    value={federalWithholdingOptions.find(opt => opt.value === data.pisCofinsRetentionCode)}
                    getOptionLabel={(option) => option.label}
                    sx={{ width: '30rem' }}
                    onChange={(e, val) => setData(prev => ({ ...prev, pisCofinsRetentionCode: val?.value || '' }))}
                    renderInput={(params) => (
                        <TextField {...params} placeholder="Selecionar" />
                    )}
                />
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '2rem' }}>
                <Box sx={{ display: 'flex', gap: '1.5rem' }}>
                    <Box sx={{ display: 'flex', gap: '1.5rem' }}>
                        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                            <FormLabel sx={{ color: 'text.primary' }}><b> Alíquota PIS </b></FormLabel>
                            <PercentNumberField
                                value={data.pisRetentionRate || null}
                                onChange={(e) => setData({ ...data, pisRetentionRate: e.target.value })}
                            />
                        </Box>
                    </Box>
                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                        <FormLabel sx={{ color: 'text.primary' }}><b> Alíquota COFINS </b></FormLabel>
                        <PercentNumberField
                            value={data.cofinsRetentionRate || null}
                            onChange={(e) => setData({ ...data, cofinsRetentionRate: e.target.value })}
                        />
                    </Box>
                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                        <FormLabel sx={{ color: 'text.primary' }}><b> Alíquota CSLL </b></FormLabel>
                        <PercentNumberField
                            value={data.csllRetentionRate || null}
                            onChange={(e) => setData({ ...data, csllRetentionRate: e.target.value })}
                        />
                    </Box>
                </Box>
                <Box sx={{ display: 'flex', gap: '1.5rem' }}>
                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                        <FormLabel sx={{ color: 'text.primary' }}><b> Alíquota retenção INSS </b></FormLabel>
                        <PercentNumberField
                            value={data.inssRetentionRate || null}
                            onChange={(e) => setData({ ...data, inssRetentionRate: e.target.value })}
                        />
                    </Box>
                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                        <FormLabel sx={{ color: 'text.primary' }}><b> Alíquota retenção IRRF </b></FormLabel>
                        <PercentNumberField
                            value={data.irrfRetentionRate || null}
                            onChange={(e) => setData({ ...data, irrfRetentionRate: e.target.value })}
                        />
                    </Box>
                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                        <FormLabel sx={{ color: 'text.primary' }}><b> Alíquota retenção CPP </b></FormLabel>
                        <PercentNumberField
                            value={data.cppRetentionRate || null}
                            onChange={(e) => setData({ ...data, cppRetentionRate: e.target.value })}
                        />
                    </Box>
                </Box>
            </Box>
        </Box>
    );
}

export default FiscalConfigTaxData;
